import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import IaAgentsAPI from '../../api/iaAgents';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getIAAgents(_state) {
    return _state.records;
  },
  getActiveAgents(_state) {
    return _state.records.filter(r => r.active);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getIAAgents({ commit }) {
    commit(types.SET_IA_AGENT_UI_FLAG, { isFetching: true });
    try {
      const response = await IaAgentsAPI.get();
      const data = response.data.data || response.data;
      commit(types.SET_IA_AGENTS, data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_IA_AGENT_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createIAAgent({ commit }, agentObj) {
    commit(types.SET_IA_AGENT_UI_FLAG, { isCreating: true });
    try {
      const response = await IaAgentsAPI.create(agentObj);
      const data = response.data.data || response.data;
      commit(types.ADD_IA_AGENT, data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_IA_AGENT_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateIAAgent({ commit }, { id, ...updateObj }) {
    commit(types.SET_IA_AGENT_UI_FLAG, { isUpdating: true });
    try {
      const response = await IaAgentsAPI.update(id, updateObj);
      const data = response.data.data || response.data;
      commit(types.EDIT_IA_AGENT, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_IA_AGENT_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteIAAgent({ commit }, id) {
    commit(types.SET_IA_AGENT_UI_FLAG, { isDeleting: true });
    try {
      await IaAgentsAPI.delete(id);
      commit(types.DELETE_IA_AGENT, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_IA_AGENT_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_IA_AGENT_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_IA_AGENTS]: MutationHelpers.set,
  [types.ADD_IA_AGENT]: MutationHelpers.create,
  [types.EDIT_IA_AGENT]: MutationHelpers.update,
  [types.DELETE_IA_AGENT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
